// import { useMediaQuery } from "@mui/material";
import styles from './styles.module.scss';
import { useOAuth2 } from '@tasoskakour/react-use-oauth2';
import { useState, useEffect } from 'react';

export default function Navigation({ menu, orientation }) {
  //   const isMobile = useMediaQuery("(max-width: 600px)");
  const [user, setUser] = useState(null);

  const { data, loading, error, getAuth, logout } = useOAuth2({
    authorizeUrl: 'https://identity.diplomacy.edu/oauth2/authorize',
    clientId: 'vF8Ejz33DsymTlrceNaMdfjsxHMa',
    redirectUri: `${document.location.origin}/callback`,
    scope: 'openid',
    responseType: 'code',
    exchangeCodeForTokenQueryFn: async (callbackParameters) => {
      const clientId = 'vF8Ejz33DsymTlrceNaMdfjsxHMa';
      const { code } = callbackParameters;
      const body = {
        grant_type: 'authorization_code',
        client_id: clientId,
        redirect_uri: `${document.location.origin}/callback`,
        code,
        scope: 'openid',
      };

      const formBody = [];
      for (const key in body) {
        formBody.push(`${encodeURIComponent(key)}=${encodeURIComponent(body[key])}`);
      }

      const response = await fetch('https://h.diplomacy.edu:9443/oauth2/token', {
        method: 'POST',
        body: formBody.join('&'),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
      });
      if (!response.ok) throw new Error('Failed');
      const tokenData = await response.json();
      return tokenData;
    },
    onSuccess: (payload) => {
      setUser(payload.user.email);
      console.log('SSO Established!');
      console.log(payload.user.email);
      localStorage.setItem('diploAccessKey', payload.token);
      localStorage.setItem('diploAccessUser', payload.user.email);
    },
    onError: (error_) => console.log('Error', error_),
  });

  const logoutUser = () => {
    logout();
    localStorage.removeItem('diploAccessKey');
    localStorage.removeItem('diploAccessUser');
    window.location.href = '/';
  };

  useEffect(() => {
    const loggedInUser = localStorage.getItem('diploAccessUser');
    console.log('loggedInUser', loggedInUser);
    setUser(loggedInUser);
  });

  return (
    <nav className={styles.navigationWrapper}>
      <ul className={orientation === 'vertical' ? `${styles.navigation} ${styles.vertical}` : styles.navigation}>
        {user &&
          menu.map((item, index) => (
            <li key={index}>
              <a href={item.path}>{item.title}</a>
            </li>
          ))}

        {user && (
          <li>
            <a href="#" onClick={() => logoutUser()}>
              Logout
            </a>
          </li>
        )}

        {user ? (
          ''
        ) : (
          <li>
            <a href="#" onClick={() => getAuth()}>
              Login
            </a>
          </li>
        )}
      </ul>
    </nav>
  );
}